import React, { useContext, useEffect, useState } from "react";
import CommonModal from "../CommonModal";
import Select from "../../Elements/Select";
import { businessTypes } from "../../../hooks/utils";
import { networkService } from "../../config/axios";
import CustomForm from "../../CommonComponents/CustomForm/CustomForm";
import { csrfToken } from "../../../utis/csrfTokenUtils";
import UserInfoContext from "../../../utis/userInfoContext";
import { AdminFormInput, AdminModalFooter } from "../../Admin/Shared";
import "../../Admin/Shared/AdminModal.css";

const AddOrganisation = ({ openModal, closeModal, orgData }) => {
  const AddOrganisationBody = () => {
    const initialState = {
      name: "",
      company_type: "",
      trial: "",
      payment_threshold: "",
      licences: "",
      licence_threshold: "",
    };
    const { setShowNotifications } = useContext(UserInfoContext);

    const [company, setCompany] = useState({
      ...initialState,
    });
    const [error, setError] = useState({});

    const handleChange = ({ target: { name, value } }) => {
      setError({
        [name]: "",
      });
      setCompany({
        ...company,
        [name]: value,
      });
    };

    const handleValidations = (company) => {
      let hasError = false;
      const newErrors = {};

      if (!company?.name) {
        newErrors.name = "Please add the Organisation name";
        hasError = true;
      }
      if (!company?.company_type) {
        newErrors.company_type = "Please select the Organisation type";
        hasError = true;
      }
      if (!company?.trial) {
        newErrors.trial = "Please enter the trial period";
        hasError = true;
      }
      if (!company?.payment_threshold) {
        newErrors.payment_threshold = "Please enter the payment threshold";
        hasError = true;
      }
      if (!company?.licences) {
        newErrors.licences = "Please enter the licence";
        hasError = true;
      }
      if (!company?.licence_threshold) {
        newErrors.licence_threshold = "Please enter the licence threshold";
        hasError = true;
      }

      if (hasError) {
        setError({ ...error, ...newErrors });
        return false;
      } else {
        return true;
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      if (handleValidations(company)) {
        const url = company?.id
          ? `admin/orgs/${company?.id}.json`
          : "admin/orgs.json";
        const data = {
          authenticity_token: csrfToken(),
          company: {
            name: company?.name,
            company_type: company?.company_type,
            trial: company?.trial,
            payment_threshold: company?.payment_threshold,
            licences: company?.licences,
            licence_threshold: company?.licence_threshold,
          },
          ...(company?.id && { id: company?.id }),
        };
        await networkService(url, company?.id ? "PATCH" : "POST", data)
          .then((response) => {
            if (response?.status === 200 || response?.status == 201) {
              setCompany({ ...initialState });
              closeModal(null);
              setShowNotifications({
                showToast: true,
                toastType: "success",
                toastMessage: `Organisation ${company?.id ? "Updated" : "Added"
                  }`,
              });
            }
          })
          .catch((error) => {
            setShowNotifications({
              showToast: true,
              toastType: "danger",
              toastMessage: error?.response?.data?.errors?.name[0] ?? "Something went wrong",
            });
          });
      }
    };

    useEffect(() => {
      setCompany({
        ...orgData,
      });
    }, [orgData]);

    return (
      <CustomForm className="org-form-pop">
        <div className="form-row form-row-3">
          <AdminFormInput
            label="Organisation name"
            name="name"
            value={company?.name}
            onChange={handleChange}
            error={error?.name}
            required={true}
          />
          <AdminFormInput
            label="Trial Period (in days)"
            name="trial"
            type="number"
            value={company?.trial}
            onChange={handleChange}
            error={error?.trial}
            required={true}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
          />
          <AdminFormInput
            label="Payment threshold (in days)"
            name="payment_threshold"
            type="number"
            value={company?.payment_threshold}
            onChange={handleChange}
            error={error?.payment_threshold}
            required={true}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
          />
        </div>

        <div className="form-row form-row-3">
          <div className="form-group">
            <label className="admin-form-label">Organisation Type</label>
            <Select
              className="admin-form-input"
              name="company_type"
              required={true}
              placeholder="Please Select"
              onChange={(e) => handleChange(e)}
              defaultValue={company.company_type ?? company?.type}
              optionList={businessTypes()?.map((type) => {
                return {
                  value: type.value,
                  title: type.name,
                };
              })}
            />
            {error?.company_type && (
              <p className="admin-form-error">{error?.company_type}</p>
            )}
          </div>
          <AdminFormInput
            label="Number of licenses"
            name="licences"
            type="number"
            value={company?.licences}
            onChange={handleChange}
            error={error?.licences}
            required={true}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
          />
          <AdminFormInput
            label="Licenses threshold"
            name="licence_threshold"
            type="number"
            value={company?.licence_threshold}
            onChange={handleChange}
            error={error?.licence_threshold}
            required={true}
            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
          />
        </div>

        <AdminModalFooter
          onCancel={closeModal}
          onSubmit={handleSubmit}
          submitText={company?.id ? "Update" : "Add"}
        />
      </CustomForm>
    );
  };

  return (
    <CommonModal
      title={orgData?.id ? "Edit Organisation" : "Add Organisation"}
      modalStatus={openModal}
      changeActiveStatus={() => closeModal()}
      classList="admin-modal admin-org-modal"
      centered
      showFooter={false}
    >
      <AddOrganisationBody />
    </CommonModal>
  );
};
export default AddOrganisation;
